import { render } from "./BookingUnderApprovalRejectModal.vue?vue&type=template&id=010f2b31&scoped=true"
import script from "./BookingUnderApprovalRejectModal.vue?vue&type=script&lang=js"
export * from "./BookingUnderApprovalRejectModal.vue?vue&type=script&lang=js"

import "./BookingUnderApprovalRejectModal.vue?vue&type=style&index=0&id=010f2b31&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-010f2b31"]])

export default __exports__